import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import StaticControl from '../../../lib/ui/StaticControl'

export default class About {
  constructor (element) {
    let displayBoolean = (value) => {
      if (typeof value === 'undefined') {
        return 'Nee'
      }

      return value ? 'Ja' : 'Nee'
    }
    let portrait = typeof window.orientation !== 'undefined' && (window.orientation !== -90 && window.orientation !== 90)

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Over PRIM',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      }],
      contextMenu: [
        {
          onclick: () => {
            location.reload(true)
          },
          icon: '\ue0da',
          label: 'Applicatie herstarten'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let fieldsetApplication = document.createElement('fieldset')
    let legendApplication = document.createElement('legend')
    legendApplication.innerHTML = 'Applicatie'
    fieldsetApplication.appendChild(legendApplication)

    new StaticControl(fieldsetApplication, { label: 'PRIM versie nummer', value: window.PRIM.version })
    new StaticControl(fieldsetApplication, { label: 'PRIM versie tijdstip', value: window.PRIM.buildTimestamp })

    let fieldsetLicense = document.createElement('fieldset')
    let legendLicense = document.createElement('legend')
    legendLicense.innerHTML = 'Abonnement'
    fieldsetLicense.appendChild(legendLicense)

    if (window.PRIM.License) {
      if (window.PRIM.License.isDemo) {
        new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Demonstratieversie, er zullen geen gegevens worden bewaard'})
      } else if (window.PRIM.License.validThru) {
        if (window.PRIM.License.valid) {
          new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt t/m ' + new Date(window.PRIM.License.validThru) })
        } else { 
          new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Is verlopen op ' + new Date(window.PRIM.License.validThru) + ', beperkingen actief' })
        }
      } else if (window.PRIM.License.valid) {
        new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Loopt onbeperkt'})
      } else {
        new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' })
      }
    } else {
      new StaticControl(fieldsetLicense, { label: 'Uw PRIM abonnement', value: 'Onbekend, beperkingen actief' })
    }

    let fieldsetSpecifications = document.createElement('fieldset')
    let legendSpecifications = document.createElement('legend')
    legendSpecifications.innerHTML = 'Specificaties'
    fieldsetSpecifications.appendChild(legendSpecifications)

    new StaticControl(fieldsetSpecifications, { label: 'Browser agent', value: navigator.userAgent })
    new StaticControl(fieldsetSpecifications, { label: 'Browser platform', value: navigator.platform })
    new StaticControl(fieldsetSpecifications, { label: 'Browser taal', value: navigator.language })
    new StaticControl(fieldsetSpecifications, { label: 'Browser is online', value: displayBoolean(navigator.onLine) })
    new StaticControl(fieldsetSpecifications, { label: 'Scherm ruimte', value: screen.availWidth + '×' + screen.availHeight + '×' + screen.pixelDepth })
    new StaticControl(fieldsetSpecifications, { label: 'Scherm orientatie', value: typeof window.orientation !== 'undefined' ? (portrait ? 'Portrait' : 'Landscape') : 'Onbekend' })

    div.appendChild(fieldsetApplication)
    div.appendChild(fieldsetLicense)
    div.appendChild(fieldsetSpecifications)

    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/about/action/About.js